import React from "react";
import { useLocation } from "react-router-dom";
import "./NotFoundGeneric.scss";

interface NotFoundGenericProps {}

function NotFoundGeneric(props: NotFoundGenericProps) {
  const location = useLocation();
  return (
    <div className="not-found-generic">
      <div className="not-found-card">
        <div>Page Not Found</div>
        <div>{location.pathname}</div>
      </div>
    </div>
  );
}
export { NotFoundGeneric as default };
